import styled from '@emotion/styled/macro';
import { Box, Container, Typography, useTheme } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Link } from 'react-router-dom';
import { imageOnError } from '../../helpers';
import { FONT_STYLE, TRANSITION_DURATION } from '../../variables';

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  lineHeight: '1.2',
  fontWeight: FONT_STYLE.bold,
  color: 'white',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.6rem',
    lineHeight: '1.25',
  },
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  fontWeight: FONT_STYLE.light,
  color: 'white',
  marginTop: theme.spacing(1.5),
}));

const Image = styled(Box)(() => ({
  aspectRatio: '16/9',
  objectFit: 'cover',
  filter: 'brightness(80%)',
  transition: `filter ${TRANSITION_DURATION}ms ease`,
}));

const SecondaryBannerBlock = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    [Image]: {
      filter: 'brightness(75%)',
    },
  },
}));

const SecondaryBanner = ({ data }) => {
  const theme = useTheme();

  return (
    <Container sx={{ paddingY: { xs: 2, md: 4 } }}>
      <Grid2
        container
        spacing={{ xs: 2 }}
      >
        {data.map(({ title, subtitle, image, url }, index) => (
          <Grid2
            key={`secundary-banner-${index}`}
            xs={12}
            sm={6}
          >
            <SecondaryBannerBlock
              component={Link}
              to={url}
              title={title}
            >
              <Box
                sx={{
                  position: 'absolute',
                  left: theme.spacing(4),
                  maxWidth: '50%',
                  zIndex: 1,
                }}
              >
                {title && <Title>{title}</Title>}
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
              </Box>
              <Image
                component='img'
                src={image}
                width='100%'
                alt={title}
                onError={(e) => {
                  imageOnError(e);
                }}
              />
            </SecondaryBannerBlock>
          </Grid2>
        ))}
      </Grid2>
    </Container>
  );
};

export default SecondaryBanner;
